import { defineComponent as _defineComponent } from 'vue'
import Cleave from "vue-cleave-component";
  import { required, numeric, minLength } from "@vuelidate/validators";
  import { validPhoneNumber } from "@/helpers/validation";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import useVuelidate from "@vuelidate/core";
  import { computed, onMounted, ref } from "vue";
  import { StatesEnum } from "@/enums/StatesEnum";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import router from "@/router";
  import { helpers } from "@vuelidate/validators";
  import store from "@/store";
  import { useToast, POSITION } from "vue-toastification";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerProfileEditView',
  setup(__props, { expose: __expose }) {
  __expose();

  const user = computed(() => store.state.user.data);
  const toast = useToast();
  const rules = computed(() => ({
    firstName: { required, $autoDirty: true },
    lastName: { required, $autoDirty: true },
    phone: {
      required,
      validPhoneNumber: helpers.withMessage(
        "Value must be valid phone number",
        validPhoneNumber
      ),
      $autoDirty: true,
    },
    details: {
      address: { required, $autoDirty: true },
      postcode: { required, numeric, minLength: minLength(4) },
    },
  }));
  let form = ref({});
  const v$ = useVuelidate(rules, form);

  const setDefaultData = () => {
    const {
      firstName,
      lastName,
      middleName,
      phone,
      email,
      detailsId: { address, postcode },
    } = user.value;

    Object.assign(form.value, {
      firstName,
      lastName,
      middleName,
      phone,
      email,
      details: {
        address,
        postcode,
      },
    });
  };

  onMounted(() => {
    setDefaultData();
  });

  async function submitForm() {
    v$.value.$touch();
    const isNoErrors = await v$.value.$validate();

    if (!isNoErrors) return;

    const { details, ...userData } = form.value;

    updateCustomerDetails(details).then(() => {
      updateUser(userData);
    });
  }
  function updateUser(data) {
    store
      .dispatch("user/updateUser", { id: user.value._id, data })
      .then(() => {
        toast.success("Profile updated successfully", {
          position: POSITION.TOP_LEFT,
        });
        router.go(-1);
      })
      .catch(() => {
        toast.error("Something went wrong", {
          position: POSITION.TOP_LEFT,
        });
      });
  }
  function updateCustomerDetails(data) {
    return store.dispatch("customer/updateCustomerDetails", {
      id: user.value.detailsId._id,
      data,
    });
  }
  function onCancel() {
    setDefaultData();
    router.go(-1);
  }
  function onBack() {
    router.push({ name: "CustomerProfile" });
  }

const __returned__ = { user, toast, rules, get form() { return form }, set form(v) { form = v }, v$, setDefaultData, submitForm, updateUser, updateCustomerDetails, onCancel, onBack, get Cleave() { return Cleave }, get required() { return required }, get numeric() { return numeric }, get minLength() { return minLength }, get validPhoneNumber() { return validPhoneNumber }, get phoneNumberOption() { return phoneNumberOption }, get useVuelidate() { return useVuelidate }, computed, onMounted, ref, get StatesEnum() { return StatesEnum }, DropDown, get router() { return router }, get helpers() { return helpers }, get store() { return store }, get useToast() { return useToast }, get POSITION() { return POSITION } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})